import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import Store from '../store'

Vue.use(VueRouter)
Vue.use(Meta)

import home_routes from './home.js'
import portal_routes from './portal.js'

const routes = [
	// ...home_routes,
	// ...portal_routes,
	// {
	// 	path: '/login',
	// 	name: 'Login',
	// 	component: () => import('@/views/portal/account/Login.vue')
	// },
	// {
	// 	path: '/register',
	// 	name: 'Register',
	// 	component: () => import('@/views/portal/account/Register.vue')
	// }
	{
		path: '/',
		name: 'Closing',
		component: () => import('@/layouts/closing')
	}
]

const router = new VueRouter({
	mode: 'history',
	linkActiveClass: 'uk-active', // this overrides the default active class added to active routes
	scrollBehavior: (to, from, savedPosition) => {
		if (savedPosition) {
			return savedPosition
		} else if (to.hash) {
			return {
				selector: to.hash
			}
		} else {
			return { x: 0, y: 0 }
		}
	},
	routes: routes,
})

// router.beforeEach( (to, from, next) => {
//   try {
//     if ( to.matched.some( (record) => record.meta.requiresAuth ) ) {
//       //route requires auth. check if logged in && validate. Will add permissions here later
//       if(Store.state.auth.is_logged_in) {
//         next();
//       } else {
//         Store.dispatch('auth/LOGOUT');
//         next({
//           path: '/login',
//           query: { redirect: to.fullPath }
//         });
//       }
//     } else { //route doesn't require auth
//       next();
//     }
//   } catch (err) {
//     next(from.fullPath);
//   }
// });

export default router
